import PropTypes from "prop-types";
import { Grid, IconButton } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { animateScroll as scroll } from "react-scroll";

const HorizontalArrows = ({ children, scrollContainerWidth, getDuration }) => {
  return (
    <Grid container flexDirection="row" wrap="nowrap">
      <IconButton
        aria-label="previous"
        color="primary"
        onClick={() =>
          scroll.scrollMore(-scrollContainerWidth, {
            duration: -getDuration,
            containerId: "scroll-container",
            horizontal: true,
          })
        }
        size="large"
      >
        <KeyboardArrowLeftIcon sx={{ fontSize: 60 }} />
      </IconButton>
      {children}
      <IconButton
        aria-label="next"
        color="primary"
        onClick={() =>
          scroll.scrollMore(scrollContainerWidth, {
            duration: getDuration,
            containerId: "scroll-container",
            horizontal: true,
          })
        }
        size="large"
      >
        <KeyboardArrowRightIcon sx={{ fontSize: 60 }} />
      </IconButton>
    </Grid>
  );
};

HorizontalArrows.propTypes = {
  scrollContainerWidth: PropTypes.number.isRequired,
  getDuration: PropTypes.func.isRequired,
};

export default HorizontalArrows;
